const state = {
    error: null,
    products: [],
    editProduct: false
};

export default state;
